import { TaskInterface, TaskTemplateInterface } from 'app/task/models';

export interface TaskStateInterface {
  ids?: number[];
  tasks?: { [id: number ]: TaskInterface };
  selectedTask?: number;
  currentTask?: TaskInterface;
  taskTemplates?: TaskTemplateInterface[];
}

export class TaskState implements TaskStateInterface {
  public ids?: number[];
  public tasks?: { [id: number ]: TaskInterface };
  public selectedTask?: number | null;
  public currentTask?: TaskInterface;
  public taskTemplates?: TaskTemplateInterface[];

  constructor({
    ids = undefined,
    tasks = undefined,
    selectedTask = undefined,
    currentTask = undefined,
    taskTemplates = undefined,
    }: TaskStateInterface) {
    this.ids = ids;
    this.tasks = tasks;
    this.selectedTask = selectedTask;
    this.currentTask = currentTask;
    this.taskTemplates = taskTemplates;
  }
}
